import ficha5 from "@assets/images/lottery-icons/fichas/ficha_05.svg";
import ficha10 from "@assets/images/lottery-icons/fichas/ficha_10.svg";
import ficha20 from "@assets/images/lottery-icons/fichas/ficha_20.svg";
import ficha50 from "@assets/images/lottery-icons/fichas/ficha_50.svg";
import ficha100 from "@assets/images/lottery-icons/fichas/ficha_100.svg";

export const fichas = [
  {value: 5, name: "ficha5", image: ficha5},
  {value: 10, name: "ficha10", image: ficha10},
  {value: 20, name: "ficha20", image: ficha20},
  {value: 50, name: "ficha50", image: ficha50},
  {value: 100, name: "ficha100", image: ficha100},
];

export const MAX_TOTAL_BET = 10000;
